module.exports = __webpack_public_path__ + "static/img/lottery-open.f9f8f4c.e135932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live/lottery-open.f9f8f4c.png
// module id = Qtoa
// module chunks = 56